module.exports = __webpack_public_path__ + "img/signup.8bfe5c64.jpg";